var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenImageAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 636.43,
    height: 606.269,
    viewBox: "0 0 636.43 606.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1220",
    "data-name": "Caminho 1220",
    d: "M813.32,195.865l-631.095,3.274V802.133l631.095-3.274Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_400",
    "data-name": "Ret\\xE2ngulo 400",
    width: 379.947,
    height: 39.601,
    transform: "translate(214.629 417.612)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_402",
    "data-name": "Ret\\xE2ngulo 402",
    width: 35.947,
    height: 5.938,
    transform: "translate(504.088 539.99)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_404",
    "data-name": "Ret\\xE2ngulo 404",
    width: 41.895,
    height: 8.174,
    transform: "translate(435.93 456.24)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_406",
    "data-name": "Ret\\xE2ngulo 406",
    width: 41.895,
    height: 8.174,
    transform: "translate(435.93 472.927)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_408",
    "data-name": "Ret\\xE2ngulo 408",
    width: 41.895,
    height: 9.039,
    transform: "translate(435.93 492.861)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_410",
    "data-name": "Ret\\xE2ngulo 410",
    width: 4.093,
    height: 4.049,
    transform: "translate(654.519 769.935)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_409",
    "data-name": "Ret\\xE2ngulo 409",
    width: 4.094,
    height: 4.048,
    transform: "translate(654.519 769.935)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_412",
    "data-name": "Ret\\xE2ngulo 412",
    width: 51.36,
    height: 13.732,
    transform: "translate(617.122 781.179)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_411",
    "data-name": "Ret\\xE2ngulo 411",
    width: 51.359,
    height: 13.731,
    transform: "translate(617.122 781.179)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_414",
    "data-name": "Ret\\xE2ngulo 414",
    width: 4.096,
    height: 4.047,
    transform: "translate(595.136 776.638)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_413",
    "data-name": "Ret\\xE2ngulo 413",
    width: 4.096,
    height: 4.047,
    transform: "translate(595.136 776.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_416",
    "data-name": "Ret\\xE2ngulo 416",
    width: 51.236,
    height: 14.398,
    transform: "translate(558.042 787.735)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_415",
    "data-name": "Ret\\xE2ngulo 415",
    width: 51.235,
    height: 14.398,
    transform: "translate(558.043 787.735)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_418",
    "data-name": "Ret\\xE2ngulo 418",
    width: 59.321,
    height: 101.147,
    transform: "translate(669.032 529.958)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_417",
    "data-name": "Ret\\xE2ngulo 417",
    width: 59.321,
    height: 101.145,
    transform: "translate(669.032 529.958)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    transform: "translate(-182.225 -195.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_399",
    "data-name": "Ret\\xE2ngulo 399",
    width: 636.43,
    height: 606.269,
    transform: "translate(182.225 195.865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M688.956,424.3l.206,67.392-28.91,1.379-.837-16.392s-10.269,2.039-12.918-7.5c-1.693-6.093-1.271-53.175-1.271-53.175Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_667",
    "data-name": "Caminho 667",
    d: "M689.461,477.079c3.078-3.2,4.5-7.647,5.217-12.028s.84-8.853,1.8-13.191c1.01-4.551,2.931-8.862,3.91-13.42s.888-9.66-1.812-13.46c0,0-1.782-5.222-9.418-5.645,0,0-6.486-10.5-16.063-9.581-13.024,1.247-13.379-2.585-22.35-4-8.386-1.319-9.945,6.156-9.945,6.156s-4.61,3.424-4.823,8.354a.965.965,0,0,1-.006.132,11.367,11.367,0,0,0,7.772,11.11q.867.291,1.741.573a11.008,11.008,0,0,1,4.57,2.3c1.814,1.807,2.11,4.617,2.017,7.18s-.457,5.205.408,7.613c.294.823,1,1.723,1.843,1.5,1.005-.267.96-1.668,1.059-2.7.285-3.016,4.162-5.307,6.889-3.1a4.619,4.619,0,0,1,1.385,5.613c-1.013,2.122-3.223,3.782-3.652,6.135-.722,3.962,3.927,7.427,5.7,9.583a16.136,16.136,0,0,0,2.029,2.128c3.836,3.229,7.6,7.694,12.641,9.443,3.383,1.171,7.5.88,10.073-1.617",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_668",
    "data-name": "Caminho 668",
    d: "M658.312,489.814s-.788-7.16.246-8.39,32.13-1.023,32.13-1.023l1.636,8.21-3.46,6.14-29.581,2.572Z",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_669",
    "data-name": "Caminho 669",
    d: "M416.515,780.3c-1.962-1.682-6.337-7.01-2.968-13.21,1.237-2.271,3.865-3.4,6.242-4.4s4.878-1.868,6.844-3.545c3.711-3.156,4.735-8.4,7.2-12.612,2.828-4.837,8.107-8.457,13.683-8.2,6.386.291,11.71,5.507,14.125,11.453s2.5,12.551,2.55,18.973c.026,3.55-.131,7.555-2.737,9.952-2.4,2.211-6.024,2.238-9.28,2.138l-34.9-1.073",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_670",
    "data-name": "Caminho 670",
    d: "M483.263,684.332H391.485l16.532,98.58a11.009,11.009,0,0,0,7.836,8.776c.11.034.22.057.321.087.275.07.538.162.818.211a11.4,11.4,0,0,0,1.869.22c.005.029.01.063.015.094l.448-.071h40.9a11.459,11.459,0,0,0,2.248-.22,11.05,11.05,0,0,0,9.286-9.635l7.968-67.922.361-2.7h-.042l3.155-26.9ZM465.95,747.214h-9.419l.949-28.61h10.913Zm3.358-28.61h9.017l-3.357,28.61h-8.1ZM442.4,778.93l-.573-24.854h13.563l-.825,24.854Zm-14.665-24.858h13.179l.573,24.854h-11.82Zm1.018,24.854H417.7c-1.05-6.706-2.419-15.432-3.9-24.854h13.02ZM427.2,747.211l-2.224-28.61H440.1l.66,28.61Zm14.465,0-.66-28.61H456.57l-.95,28.61Zm-.817-35.471-.611-26.493h17.436L456.8,711.74Zm-.912,0H424.446l-2.059-26.493h16.944Zm-16.407,0H407.14c-.579-3.66-1.131-7.125-1.628-10.24-1.71-10.711-2.354-14.74-2.71-16.255h18.672Zm.533,6.859,2.224,28.61H412.733c-.456-2.9-.918-5.84-1.381-8.78-1.063-6.752-2.127-13.505-3.127-19.83Zm-12.256,28.61h-8.856l-4.8-28.61H407.3c1.4,8.842,2.948,18.687,4.507,28.61m1.076,6.86c1.351,8.6,2.68,17.081,3.9,24.853h-8.51l-4.166-24.851Zm42.59,24.853.825-24.853h9.065l-2.124,24.853Zm2.231-67.185.879-26.491h12.653l-2.263,26.491Zm-55.767-26.489c.363,1.916,2.039,12.341,4.287,26.492h-9.212l-4.443-26.492Zm69.312,93.681h-7.1l2.124-24.854h7.879Zm7.883-67.185H469.9l2.264-26.492h10.081Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_313",
    "data-name": "Ret\\xE2ngulo 313",
    width: 142.521,
    height: 96.065,
    transform: "translate(580.03 264.129) rotate(-9.613)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_671",
    "data-name": "Caminho 671",
    d: "M720.542,240.321a10.051,10.051,0,0,1-1.1,1.482l-3.331,4.091-12.441,14.9L662.142,309.77l-.342.4-.465-.258-1.12-.621-56.83-31.706-17.147-9.731-4.632-2.706a10.065,10.065,0,0,1-1.572-1.019,9.989,9.989,0,0,1,1.7.793l4.749,2.491,17.35,9.377c14.7,8.087,36.886,19.149,59.1,31.374l-.962.621-.8.147,41.814-48.724,12.751-14.637q2.19-2.451,3.518-3.933a9.934,9.934,0,0,1,1.291-1.319",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_672",
    "data-name": "Caminho 672",
    d: "M596.078,358.84c-.308-.181,8.058-14.95,18.687-32.992,12.06-20.483,23.612-30.083,19.8-32.34.307.182-8.057,14.95-18.687,33s-19.491,32.517-19.8,32.336",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_673",
    "data-name": "Caminho 673",
    d: "M681.071,284.41c.241-.264,12.861,10.856,28.2,24.833s27.566,25.525,27.325,25.79S725.818,324.18,710.481,310.2s-29.646-25.523-29.4-25.788",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_314",
    "data-name": "Ret\\xE2ngulo 314",
    width: 71.588,
    height: 48.253,
    transform: "translate(221.484 500.236) rotate(-5.077)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_674",
    "data-name": "Caminho 674",
    d: "M292.79,493.9a5.064,5.064,0,0,1-.607.7l-1.831,1.916c-1.661,1.7-3.978,4.063-6.824,6.968l-22.742,22.869-.187.189-.22-.148-.536-.355-27.2-18.137-8.2-5.558-2.21-1.539a5.045,5.045,0,0,1-.747-.572,5.248,5.248,0,0,1,.819.465l2.279,1.436,8.314,5.387L260.2,525.5l.537.355-.408.041,22.882-22.733c2.908-2.844,5.276-5.165,6.97-6.822.8-.761,1.429-1.368,1.915-1.83a4.989,4.989,0,0,1,.7-.607",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_675",
    "data-name": "Caminho 675",
    d: "M225.755,548.3c-.146-.1,4.63-7.165,10.663-15.777s11.055-15.508,11.2-15.4-4.63,7.168-10.67,15.777-11.049,15.507-11.195,15.4",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_676",
    "data-name": "Caminho 676",
    d: "M271.272,514.41c.131-.122,6.011,5.948,13.13,13.556s12.789,13.876,12.658,14-6.01-5.946-13.133-13.557-12.787-13.878-12.656-14",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_677",
    "data-name": "Caminho 677",
    d: "M799.388,442.07s.048-.38.163-1.082q.183-1.092.522-3.094c.472-2.727,1.158-6.688,2.033-11.745,1.781-10.132,4.332-24.651,7.438-42.315l.23.329-84.719-15.125h-.007l.41-.285c-3.737,20.77-7.286,40.5-10.467,58.181l-.26-.375,60.969,11.1,17.425,3.214,4.641.873,1.2.235a3.969,3.969,0,0,1,.418.1,3.155,3.155,0,0,1-.387-.051l-1.174-.19-4.593-.785-17.383-3.032L714.615,427.2l-.317-.056.058-.32c3.162-17.68,6.691-37.417,10.406-58.192l.062-.348.349.062h.006l84.7,15.259.28.051-.051.28c-3.239,17.714-5.9,32.275-7.761,42.436-.934,5.019-1.662,8.949-2.165,11.652q-.374,1.963-.577,3.033c-.132.679-.212,1.012-.212,1.012",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_678",
    "data-name": "Caminho 678",
    d: "M809.825,383.887a7.62,7.62,0,0,1-.964.7l-2.842,1.889L795.5,393.311l-34.846,22.326c-.948-.167-.27-.057-.486-.1l-.015-.019-.029-.038-.056-.076-.11-.15-.227-.3-.456-.6-.907-1.2-1.794-2.37-3.508-4.636c-2.294-3.039-4.507-5.973-6.62-8.769L735.27,382.506l-7.486-10.065-2.007-2.757a7.443,7.443,0,0,1-.66-.99,7.515,7.515,0,0,1,.77.9q.783.988,2.112,2.677l7.666,9.929c3.229,4.224,7.055,9.234,11.3,14.782l6.654,8.745q1.727,2.277,3.517,4.628l1.8,2.37.906,1.2.457.6.229.3.11.151.056.076.03.036.014.02c-.2-.034.481.1-.457-.071l34.956-22.151,10.638-6.646,2.912-1.778a7.4,7.4,0,0,1,1.041-.578",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_679",
    "data-name": "Caminho 679",
    d: "M748.656,399.757c.122.151-7.425,6.4-16.853,13.942s-17.176,13.544-17.3,13.392,7.424-6.394,16.856-13.944,17.172-13.543,17.3-13.391",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_680",
    "data-name": "Caminho 680",
    d: "M799.812,442.846c-.172.1-5.08-8.564-10.962-19.333s-10.513-19.581-10.341-19.677,5.077,8.562,10.961,19.336,10.514,19.579,10.342,19.676",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_681",
    "data-name": "Caminho 681",
    d: "M423.4,551.715v16.35H353.076a8.177,8.177,0,0,1,0-16.354",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_682",
    "data-name": "Caminho 682",
    d: "M423.4,564.639H400.1a4.61,4.61,0,0,1-4.609-4.609v-.28a4.61,4.61,0,0,1,4.609-4.609h23.3Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_683",
    "data-name": "Caminho 683",
    d: "M423.4,535.355v16.357H353.076a8.178,8.178,0,0,1,0-16.357H423.4Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_684",
    "data-name": "Caminho 684",
    d: "M423.4,548.286H400.1a4.61,4.61,0,0,1-4.609-4.609v-.28a4.61,4.61,0,0,1,4.609-4.609h23.3Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_685",
    "data-name": "Caminho 685",
    d: "M372.613,509.124l-11.169,26.234h7.189l4.962-14.012Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_686",
    "data-name": "Caminho 686",
    d: "M406.91,485.384l4.315,49.974H374.719l-4.01-49.975Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_687",
    "data-name": "Caminho 687",
    d: "M403.344,489.346l3.781,41.86-27.4.36L376.019,489.1Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_688",
    "data-name": "Caminho 688",
    d: "M397.53,495.143l2.15,28.8H385.06l-2.578-28.8Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_689",
    "data-name": "Caminho 689",
    d: "M818.655,792.3c0,.2-142.481.367-318.2.367-175.778,0-318.23-.164-318.23-.367s142.451-.366,318.228-.366c175.718,0,318.2.163,318.2.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_315",
    "data-name": "Ret\\xE2ngulo 315",
    width: 379.658,
    height: 257.546,
    transform: "translate(213.323 199.475)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_690",
    "data-name": "Caminho 690",
    d: "M594.72,457.214H214.485V199.281H594.72Zm-.295-257.74H214.772V457.023H594.425",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_691",
    "data-name": "Caminho 691",
    d: "M594.72,457.214H214.485V199.281H594.72Zm-.295-257.74H214.772V457.023H594.425",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_316",
    "data-name": "Ret\\xE2ngulo 316",
    width: 379.947,
    height: 25.532,
    transform: "translate(214.629 199.426)",
    fill: "#262626"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_317",
    "data-name": "Ret\\xE2ngulo 317",
    width: 379.947,
    height: 39.601,
    transform: "translate(214.629 417.612)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_272",
    "data-name": "Grupo 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_271",
    "data-name": "Grupo 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_693",
    "data-name": "Caminho 693",
    d: "M286.746,436.777h3.137l.99,2.054h.673l-3.139-6.556h-.173l-3.147,6.556h.682Zm1.572-3.269,1.27,2.657h-2.547Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_319",
    "data-name": "Ret\\xE2ngulo 319",
    width: 7.428,
    height: 0.523,
    transform: "translate(284.58 440.228)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_694",
    "data-name": "Caminho 694",
    d: "M240.586,431.913h-.5a2.765,2.765,0,0,0-2.609,2.816,11.686,11.686,0,0,0,2.609,5.587s.2.344.5,0a11.686,11.686,0,0,0,2.609-5.587,2.765,2.765,0,0,0-2.609-2.816m-.251,4.458a1.539,1.539,0,1,1,1.539-1.539,1.539,1.539,0,0,1-1.539,1.539h0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_695",
    "data-name": "Caminho 695",
    d: "M275.371,438.465a1.591,1.591,0,0,1-3.18,0v-5.137a1.029,1.029,0,0,1,2.058,0v4.357h0a.585.585,0,0,1-1.143-.009v-3.354h-.381v3.363h.012a.95.95,0,0,0,1.883,0h.005V437.6c0-.024.006-.046.006-.072h-.006v-4.246a1.413,1.413,0,0,0-2.823,0v5.365h.01a1.972,1.972,0,0,0,3.928,0h.009v-4.323h-.383Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_696",
    "data-name": "Caminho 696",
    d: "M258.463,434.572l-1.472-2.98-1.471,2.98-3.289.477,2.379,2.321-.562,3.276,2.943-1.548,2.942,1.547-.562-3.277,2.38-2.32Zm.833,5.2-2.309-1.207-2.309,1.209.42-2.44.024-.127-1.867-1.817,2.579-.375,1.149-2.336,1.156,2.336,2.575.375-1.767,1.733-.089.086Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_320",
    "data-name": "Ret\\xE2ngulo 320",
    width: 0.478,
    height: 15.265,
    transform: "translate(315.894 427.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_321",
    "data-name": "Ret\\xE2ngulo 321",
    width: 6.077,
    height: 6.477,
    transform: "translate(300.953 433.333)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_697",
    "data-name": "Caminho 697",
    d: "M302.873,431.818v.5h2.239v-.5h1.918v1h-6.077v-1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_322",
    "data-name": "Ret\\xE2ngulo 322",
    width: 2.239,
    height: 0.498,
    transform: "translate(302.873 431.32)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_323",
    "data-name": "Ret\\xE2ngulo 323",
    width: 2.239,
    height: 0.498,
    transform: "translate(302.873 431.818)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_698",
    "data-name": "Caminho 698",
    d: "M330.131,436.8,332,434.934l.226.227-2.088,2.088-2.089-2.088.226-.227Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_699",
    "data-name": "Caminho 699",
    d: "M559.141,212.472h5.267v-.558h-5.267Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_700",
    "data-name": "Caminho 700",
    d: "M585.413,209.756l-.4-.4-2.436,2.438-2.432-2.429-.393.4,2.436,2.436-2.436,2.437.393.4,2.436-2.437,2.436,2.437.4-.4-2.435-2.438Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_701",
    "data-name": "Caminho 701",
    d: "M569.133,215.106h5.826v-5.833h-5.826Zm.56-5.268H574.4v4.711h-4.709Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_702",
    "data-name": "Caminho 702",
    d: "M585.987,283.207a2.068,2.068,0,0,0-2-2.064h-7.851v.013a2.887,2.887,0,0,0,0,5.749v.014h6.327v-.564H576.4a2.326,2.326,0,1,1-.1-4.651h7.62a1.506,1.506,0,0,1,0,3.012h-6.376v.006a.854.854,0,0,1,.011-1.678h4.909v-.562h-4.92v.023a1.389,1.389,0,0,0,0,2.748v.012h.126c.036,0,.07.011.1.011v-.011h6.214a2.072,2.072,0,0,0,2-2.064",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_703",
    "data-name": "Caminho 703",
    d: "M231.908,207.856v6.99h-.819l-4.2-5.213v5.213h-1v-6.99h.818l4.2,5.209v-5.209Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_704",
    "data-name": "Caminho 704",
    d: "M238.619,212.518h-4.294a1.794,1.794,0,0,0,1.917,1.547,1.981,1.981,0,0,0,1.528-.639l.529.619a2.885,2.885,0,0,1-4.933-1.848,2.591,2.591,0,0,1,2.484-2.694h.173a2.549,2.549,0,0,1,2.62,2.478v0a2.235,2.235,0,0,1-.005.245c0,.079-.01.2-.019.288m-4.294-.688h3.4a1.708,1.708,0,0,0-3.4,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_705",
    "data-name": "Caminho 705",
    d: "M247.869,209.553l-1.979,5.293h-.919l-1.525-4.015-1.548,4.016h-.918l-1.969-5.295h.909l1.539,4.213,1.6-4.216h.809l1.568,4.234,1.578-4.234Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_706",
    "data-name": "Caminho 706",
    d: "M256.725,213.978v.868h-5.074v-6.99h4.932v.87H252.65v2.146h3.505v.848H252.65v2.258Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    "data-name": "Caminho 707",
    d: "M266.982,211.8v3.046h-.962V211.91c0-1.039-.5-1.548-1.367-1.548a1.538,1.538,0,0,0-1.6,1.473,1.613,1.613,0,0,0,.014.286v2.726h-.958V211.91c0-1.039-.5-1.548-1.37-1.548a1.537,1.537,0,0,0-1.585,1.759v2.726H258.2v-5.294h.919v.789a2.145,2.145,0,0,1,1.827-.838,1.953,1.953,0,0,1,1.838.978,2.384,2.384,0,0,1,2.036-.978,2.029,2.029,0,0,1,2.18,1.865h0a2.061,2.061,0,0,1-.012.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    "data-name": "Caminho 708",
    d: "M272.932,211.651v3.194h-.907v-.7a1.967,1.967,0,0,1-1.738.758c-1.2,0-1.956-.639-1.956-1.557,0-.849.549-1.548,2.127-1.548h1.52v-.189c0-.809-.468-1.279-1.417-1.279a2.666,2.666,0,0,0-1.677.569l-.4-.718a3.524,3.524,0,0,1,2.187-.679c1.448,0,2.266.7,2.266,2.147m-.959,1.577v-.74h-1.483c-.948,0-1.217.369-1.217.82,0,.528.44.858,1.169.858a1.539,1.539,0,0,0,1.527-.938",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    "data-name": "Caminho 709",
    d: "M274.533,207.916a.631.631,0,0,1,.634-.628h.015a.62.62,0,0,1,.648.59h0v.017a.65.65,0,1,1-1.3.02m.17,1.637h.959v5.293H274.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_324",
    "data-name": "Ret\\xE2ngulo 324",
    width: 0.959,
    height: 7.41,
    transform: "translate(277.486 207.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    "data-name": "Caminho 710",
    d: "M226.3,233.658h-2.4v-.868h5.781v.868h-2.4v6.122H226.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    "data-name": "Caminho 711",
    d: "M229.59,237.137a2.748,2.748,0,1,1,2.787,2.707h-.031a2.633,2.633,0,0,1-2.754-2.505h0v-.2m4.533,0a1.784,1.784,0,1,0-1.777,1.869,1.736,1.736,0,0,0,1.777-1.691,1.322,1.322,0,0,0,0-.178",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    "data-name": "Caminho 712",
    d: "M238.648,235.118a.669.669,0,0,1,.655-.68h.022a.66.66,0,0,1,.66.66v.02a.667.667,0,0,1-.643.689h-.017a.675.675,0,0,1-.678-.673h0v-.016m0,4.035a.666.666,0,0,1,.655-.679h.023a.66.66,0,0,1,.66.659h0v.021a.656.656,0,0,1-.626.686h-.034a.676.676,0,0,1-.678-.672v-.018",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M225.325,259.8a3.535,3.535,0,0,1,3.491-3.579h.218a3.458,3.458,0,0,1,2.656,1.089l-.649.628a2.586,2.586,0,0,0-1.968-.829,2.688,2.688,0,0,0-.153,5.374h.153a2.6,2.6,0,0,0,1.968-.84l.649.631a3.474,3.474,0,0,1-2.667,1.1,3.534,3.534,0,0,1-3.691-3.367c0-.069-.005-.139,0-.208",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M232.261,260.648a2.638,2.638,0,0,1,2.574-2.7c.075,0,.151,0,.226.005a2.358,2.358,0,0,1,2.155,1.128l-.728.471a1.657,1.657,0,0,0-1.437-.76,1.865,1.865,0,0,0,0,3.727,1.651,1.651,0,0,0,1.437-.76l.728.459a2.368,2.368,0,0,1-2.155,1.137,2.649,2.649,0,0,1-2.793-2.5v0c0-.068-.005-.137,0-.205",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M240.678,258.632a.669.669,0,0,1,.656-.68h.023a.66.66,0,0,1,.66.658v.022a.667.667,0,0,1-.643.688h-.017a.676.676,0,0,1-.679-.672h0v-.015m0,4.035a.668.668,0,0,1,.657-.679h.022a.659.659,0,0,1,.66.658h0v.02a.658.658,0,0,1-.63.687h-.03a.675.675,0,0,1-.679-.67v-.018",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M224.274,286.315l.368-.779a3.6,3.6,0,0,0,2.309.809c1.209,0,1.728-.469,1.728-1.079,0-1.707-4.234-.628-4.234-3.225,0-1.078.838-2,2.676-2a4.129,4.129,0,0,1,2.248.619l-.33.8a3.6,3.6,0,0,0-1.917-.568c-1.188,0-1.7.5-1.7,1.107,0,1.709,4.233.641,4.233,3.207,0,1.068-.858,1.987-2.706,1.987a4.15,4.15,0,0,1-2.676-.879",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M235.9,281.822v5.293h-.913v-.8a2.152,2.152,0,0,1-1.8.859,2.078,2.078,0,0,1-2.278-1.855v0a1.992,1.992,0,0,1,0-.45v-3.043h.958v2.935c0,1.04.518,1.558,1.429,1.558a1.556,1.556,0,0,0,1.649-1.457,1.6,1.6,0,0,0-.011-.3v-2.734Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M243.2,284.465a2.577,2.577,0,0,1-2.442,2.705h-.234a2.234,2.234,0,0,1-1.887-.9v.838h-.919v-7.4h.954v2.916a2.249,2.249,0,0,1,1.848-.849,2.568,2.568,0,0,1,2.676,2.455h0v.24m-.973,0a1.784,1.784,0,1,0-1.787,1.869,1.744,1.744,0,0,0,1.791-1.694,1.708,1.708,0,0,0,0-.175",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M242.7,288.792l.31-.739a1.218,1.218,0,0,0,.778.252c.509,0,.789-.322.789-.93v-5.554h.959v5.531a1.577,1.577,0,0,1-1.381,1.752h0a1.5,1.5,0,0,1-.3.006,1.87,1.87,0,0,1-1.149-.319m1.707-8.608a.633.633,0,0,1,.635-.629h.014a.624.624,0,1,1-.649.629",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M252.119,284.786h-4.294a1.793,1.793,0,0,0,1.917,1.548,1.975,1.975,0,0,0,1.528-.639l.529.619a2.885,2.885,0,0,1-4.936-1.849,2.592,2.592,0,0,1,2.484-2.694h.172a2.55,2.55,0,0,1,2.621,2.478,2.034,2.034,0,0,1,0,.247c0,.08-.01.2-.019.289m-4.3-.686h3.4a1.708,1.708,0,0,0-3.4,0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M252.972,284.465a2.644,2.644,0,0,1,2.588-2.7h.208a2.36,2.36,0,0,1,2.157,1.135l-.73.471a1.647,1.647,0,0,0-1.436-.76,1.869,1.869,0,0,0,0,3.726,1.647,1.647,0,0,0,1.436-.76l.73.459a2.364,2.364,0,0,1-2.158,1.138,2.653,2.653,0,0,1-2.793-2.5v-.2",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M262.2,286.806a1.818,1.818,0,0,1-1.159.368,1.51,1.51,0,0,1-1.675-1.322,1.435,1.435,0,0,1,0-.334v-2.906h-.9v-.789h.9v-1.158h.957v1.158h1.518v.789h-1.518v2.866a.782.782,0,0,0,.661.884.931.931,0,0,0,.167,0,1.2,1.2,0,0,0,.749-.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M265.59,282.451a.669.669,0,0,1,.656-.68h.023a.66.66,0,0,1,.66.66h0v.019a.668.668,0,0,1-.643.689h-.017a.677.677,0,0,1-.679-.673h0v-.016m0,4.035a.668.668,0,0,1,.657-.679h.022a.659.659,0,0,1,.66.658h0v.02a.658.658,0,0,1-.63.687h-.03a.673.673,0,0,1-.679-.668v-.024",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    "data-name": "Caminho 724",
    d: "M353.219,238.528c0,.2-22.411.366-50.048.366s-50.052-.165-50.052-.366,22.4-.367,50.052-.367,50.048.165,50.048.367",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M397.916,261.365c0,.2-32.417.365-72.395.365s-72.4-.164-72.4-.365,32.409-.366,72.4-.366,72.395.164,72.395.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M344.374,284.028a2.262,2.262,0,0,1-.66.074l-1.9.069-7.005.115c-5.914.067-14.083.11-23.107.11s-17.2-.04-23.111-.11l-7-.115-1.9-.069a2.3,2.3,0,0,1-.66-.074,2.261,2.261,0,0,1,.66-.074l1.9-.068,7-.117c5.914-.065,14.084-.11,23.111-.11s17.193.04,23.107.11l7.005.117,1.9.068a2.261,2.261,0,0,1,.66.074",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M590.476,296.355c0,.2-84.11.366-187.841.366-103.768,0-187.859-.164-187.859-.366s84.091-.365,187.859-.365c103.73,0,187.841.164,187.841.365",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M590.476,271.637c0,.2-84.143.366-187.914.366-103.807,0-187.932-.163-187.932-.366s84.125-.365,187.932-.365c103.768,0,187.914.164,187.914.365",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M590.476,249.948c0,.2-84.11.366-187.841.366-103.768,0-187.859-.164-187.859-.366s84.091-.366,187.859-.366c103.73,0,187.841.164,187.841.366",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M261.331,326.508c0,.2-5.341.366-11.928.366s-11.929-.164-11.929-.366,5.339-.365,11.929-.365,11.928.164,11.928.365",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M339.794,344.374c0,.2-22.906.366-51.157.366s-51.162-.164-51.162-.366,22.9-.366,51.162-.366,51.157.164,51.157.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M214.773,199.465c2.99,0,155.9-.132,379.658-.33h.33v.33c.01,78.386.02,165.685.031,257.515v.4h-.367c-142.893-.027-274.782-.051-379.658-.072h-.295v-.29c.179-156.808.291-255.14.295-257.55,0,2.4.109,100.738.294,257.55l-.294-.3c104.877-.02,236.765-.046,379.658-.071l-.367.365v-.031c.011-91.83.022-179.127.03-257.515l.337.337c-223.75-.2-376.67-.332-379.653-.341",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M608.175,539.99h-170.4A13.288,13.288,0,0,1,424.489,526.7V411.628a6.025,6.025,0,0,1,6.026-6.026h184.92a6.025,6.025,0,0,1,6.026,6.026h0V526.7a13.288,13.288,0,0,1-13.286,13.287",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M540.035,539.99h-34.21s-10.528,17.553,0,28.079h35.383s-17.442-11.421-1.173-28.079",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_321",
    "data-name": "Grupo 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_320",
    "data-name": "Grupo 320",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_319",
    "data-name": "Grupo 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_318",
    "data-name": "Grupo 318",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M505.825,539.99l-1.733,3.48,31.354,2.457a73.408,73.408,0,0,1,4.59-5.936Z"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M531.038,526.949a3.878,3.878,0,1,1-3.879-3.877h0a3.88,3.88,0,0,1,3.877,3.877",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_327",
    "data-name": "Ret\\xE2ngulo 327",
    width: 178.085,
    height: 102.492,
    transform: "translate(433.933 413.005)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_328",
    "data-name": "Ret\\xE2ngulo 328",
    width: 41.913,
    height: 91.308,
    transform: "translate(435.929 421.682)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_322",
    "data-name": "Grupo 322",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_329",
    "data-name": "Ret\\xE2ngulo 329",
    width: 41.895,
    height: 8.173,
    transform: "translate(435.93 456.241)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_332",
    "data-name": "Ret\\xE2ngulo 332",
    width: 41.895,
    height: 8.173,
    transform: "translate(435.93 472.928)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_335",
    "data-name": "Ret\\xE2ngulo 335",
    width: 41.895,
    height: 9.039,
    transform: "translate(435.93 492.861)"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    "data-name": "Caminho 737",
    d: "M470.554,468.7c0,.2-6.034.365-13.475.365S443.6,468.9,443.6,468.7s6.034-.366,13.477-.366,13.475.164,13.475.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    "data-name": "Caminho 738",
    d: "M470.554,460.171c0,.2-6.034.367-13.475.367s-13.477-.164-13.477-.367,6.034-.366,13.477-.366,13.475.164,13.475.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M477.841,501.9c0,.2-9.3.366-20.764.366s-20.766-.163-20.766-.366,9.3-.366,20.766-.366,20.764.163,20.764.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    "data-name": "Caminho 740",
    d: "M464.171,477.314c0,.2-4.6.366-10.284.366s-10.285-.164-10.285-.366,4.6-.366,10.285-.366,10.284.164,10.284.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_741",
    "data-name": "Caminho 741",
    d: "M467.077,496.4c0,.2-4.6.368-10.284.368s-10.285-.164-10.285-.368,4.6-.364,10.285-.364,10.284.163,10.284.364",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_742",
    "data-name": "Caminho 742",
    d: "M470.554,486.753c0,.2-6.034.365-13.475.365s-13.477-.164-13.477-.365,6.034-.366,13.477-.366,13.475.164,13.475.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_743",
    "data-name": "Caminho 743",
    d: "M470.554,507.246c0,.2-6.034.366-13.475.366s-13.477-.164-13.477-.366,6.034-.366,13.477-.366,13.475.164,13.475.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_744",
    "data-name": "Caminho 744",
    d: "M456.318,427.84a9.977,9.977,0,0,0-4.507,18.883v-3.058a4.7,4.7,0,1,1,9.4-.011v2.856a9.978,9.978,0,0,0-4.9-18.673m.2,10.412a3.518,3.518,0,1,1,3.518-3.519,3.519,3.519,0,0,1-3.518,3.519h0",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M456.515,438.965a4.7,4.7,0,0,0-4.7,4.7h0v3.054a9.929,9.929,0,0,0,9.4-.208v-2.846a4.7,4.7,0,0,0-4.7-4.7h0",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_746",
    "data-name": "Caminho 746",
    d: "M456.516,431.212a3.518,3.518,0,1,0,3.518,3.518,3.518,3.518,0,0,0-3.518-3.518h0",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_747",
    "data-name": "Caminho 747",
    d: "M466.362,437.822c-.081,0-.044-.889-.451-2.4a9.947,9.947,0,0,0-3.649-5.327,9.663,9.663,0,1,0,0,15.455,9.957,9.957,0,0,0,3.649-5.325c.407-1.513.369-2.407.451-2.4a2.091,2.091,0,0,1,.042.641,7.9,7.9,0,0,1-.22,1.831,9.953,9.953,0,0,1-3.611,5.669,10.106,10.106,0,0,1-4.3,1.963,10.285,10.285,0,1,1,4.051-18.43c.083.061.166.123.247.186a9.939,9.939,0,0,1,3.613,5.668,7.9,7.9,0,0,1,.22,1.832,2.094,2.094,0,0,1-.042.641",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_338",
    "data-name": "Ret\\xE2ngulo 338",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 452.232)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_339",
    "data-name": "Ret\\xE2ngulo 339",
    width: 131.237,
    height: 6.159,
    transform: "translate(477.844 421.684)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M571.107,425.938H482.486a1.014,1.014,0,0,1-1.014-1.012v-.386a1.015,1.015,0,0,1,1.012-1.015h88.623a1.013,1.013,0,0,1,1.013,1.011h0v.387a1.011,1.011,0,0,1-1.011,1.013Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    "data-name": "Caminho 749",
    d: "M583.762,425.938h-5.9a1.013,1.013,0,0,1-1.013-1.012h0v-.385a1.014,1.014,0,0,1,1.012-1.014h5.9a1.012,1.012,0,0,1,1.013,1.011h0v.387a1.011,1.011,0,0,1-1.011,1.013Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_340",
    "data-name": "Ret\\xE2ngulo 340",
    width: 0.993,
    height: 0.993,
    transform: "translate(588.98 423.355)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_341",
    "data-name": "Ret\\xE2ngulo 341",
    width: 0.993,
    height: 0.993,
    transform: "translate(588.98 424.669)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_342",
    "data-name": "Ret\\xE2ngulo 342",
    width: 0.993,
    height: 0.993,
    transform: "translate(590.526 423.355)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_343",
    "data-name": "Ret\\xE2ngulo 343",
    width: 0.993,
    height: 0.993,
    transform: "translate(590.526 424.669)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_344",
    "data-name": "Ret\\xE2ngulo 344",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 427.841)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_345",
    "data-name": "Ret\\xE2ngulo 345",
    width: 3.715,
    height: 3.715,
    transform: "translate(481.472 431.85)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_750",
    "data-name": "Caminho 750",
    d: "M542.588,433.7c0,.2-12.045.366-26.9.366s-26.9-.165-26.9-.366,12.043-.366,26.9-.366,26.9.164,26.9.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_751",
    "data-name": "Caminho 751",
    d: "M593.292,433.6c0,.2-1.356.366-3.032.366s-3.031-.164-3.031-.366,1.357-.366,3.031-.366,3.032.164,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_346",
    "data-name": "Ret\\xE2ngulo 346",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 464.414)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_347",
    "data-name": "Ret\\xE2ngulo 347",
    width: 3.751,
    height: 3.715,
    transform: "translate(480.972 468.423)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_752",
    "data-name": "Caminho 752",
    d: "M542.675,470.264c0,.2-12.161.366-27.159.366s-27.161-.164-27.161-.366,12.159-.366,27.161-.366,27.159.163,27.159.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_753",
    "data-name": "Caminho 753",
    d: "M593.863,470.164c0,.2-1.371.366-3.059.366s-3.062-.164-3.062-.366,1.37-.366,3.062-.366,3.059.164,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_348",
    "data-name": "Ret\\xE2ngulo 348",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 476.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_349",
    "data-name": "Ret\\xE2ngulo 349",
    width: 3.751,
    height: 3.715,
    transform: "translate(480.972 480.521)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_754",
    "data-name": "Caminho 754",
    d: "M542.675,482.365c0,.2-12.161.365-27.159.365s-27.161-.162-27.161-.365S500.514,482,515.516,482s27.159.162,27.159.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    "data-name": "Caminho 755",
    d: "M593.863,482.264c0,.2-1.371.366-3.059.366s-3.062-.163-3.062-.366,1.37-.366,3.062-.366,3.059.165,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_350",
    "data-name": "Ret\\xE2ngulo 350",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 488.612)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_351",
    "data-name": "Ret\\xE2ngulo 351",
    width: 3.751,
    height: 3.715,
    transform: "translate(480.972 492.62)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_756",
    "data-name": "Caminho 756",
    d: "M542.675,494.465c0,.2-12.161.366-27.159.366s-27.161-.164-27.161-.366,12.159-.366,27.161-.366,27.159.163,27.159.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_757",
    "data-name": "Caminho 757",
    d: "M593.863,494.365c0,.2-1.371.367-3.059.367s-3.062-.164-3.062-.367,1.37-.366,3.062-.366,3.059.164,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_352",
    "data-name": "Ret\\xE2ngulo 352",
    width: 131.237,
    height: 12.28,
    transform: "translate(477.844 500.711)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_353",
    "data-name": "Ret\\xE2ngulo 353",
    width: 3.751,
    height: 3.715,
    transform: "translate(480.972 504.719)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_758",
    "data-name": "Caminho 758",
    d: "M542.675,506.565c0,.2-12.161.366-27.159.366s-27.161-.164-27.161-.366,12.159-.366,27.161-.366,27.159.163,27.159.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_759",
    "data-name": "Caminho 759",
    d: "M593.863,506.465c0,.2-1.371.367-3.059.367s-3.062-.165-3.062-.367,1.37-.366,3.062-.366,3.059.164,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_354",
    "data-name": "Ret\\xE2ngulo 354",
    width: 131.255,
    height: 12.28,
    transform: "translate(477.825 439.966)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_355",
    "data-name": "Ret\\xE2ngulo 355",
    width: 3.715,
    height: 3.715,
    transform: "translate(481.472 443.974)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_760",
    "data-name": "Caminho 760",
    d: "M519.576,445.82c0,.2-6.893.366-15.4.366s-15.4-.164-15.4-.366,6.892-.366,15.4-.366,15.4.164,15.4.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_761",
    "data-name": "Caminho 761",
    d: "M593.292,446.176c0,.2-1.356.366-3.032.366s-3.031-.164-3.031-.366,1.357-.366,3.031-.366,3.032.164,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_762",
    "data-name": "Caminho 762",
    d: "M593.292,458.1c0,.2-1.356.368-3.032.368s-3.031-.165-3.031-.368,1.357-.366,3.031-.366,3.032.165,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_356",
    "data-name": "Ret\\xE2ngulo 356",
    width: 3.715,
    height: 3.715,
    transform: "translate(481.472 456.24)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_763",
    "data-name": "Caminho 763",
    d: "M562.97,458.086c0,.2-16.608.367-37.09.367s-37.1-.164-37.1-.367,16.605-.366,37.1-.366,37.09.165,37.09.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_764",
    "data-name": "Caminho 764",
    d: "M441.775,418.665a1.119,1.119,0,1,1-1.119-1.12,1.12,1.12,0,0,1,1.119,1.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_765",
    "data-name": "Caminho 765",
    d: "M446.139,418.665a1.119,1.119,0,1,1-1.12-1.12A1.12,1.12,0,0,1,446.139,418.665Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    "data-name": "Caminho 766",
    d: "M450.5,418.665a1.119,1.119,0,1,1-1.12-1.12,1.12,1.12,0,0,1,1.12,1.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_767",
    "data-name": "Caminho 767",
    d: "M609.08,512.99c0-2.247-.065-37.776-.169-97.476l.169.168-173.138.05h-.017l.22-.22c0,34.475-.01,67.444-.014,97.476l-.206-.2,173.151.2-173.151.205h-.2v-.205c0-30.034-.008-63-.014-97.476v-.218h.232l173.138.05h.169v.17c-.1,59.7-.165,95.231-.169,97.476",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    "data-name": "Caminho 768",
    d: "M693.725,792.3H683.143L659.536,580.313h13.889Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    "data-name": "Caminho 769",
    d: "M626.8,792.3h-10.58L592.434,580.313h13.891Z",
    fill: "#b2aaaa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_357",
    "data-name": "Ret\\xE2ngulo 357",
    width: 373.065,
    height: 12.244,
    transform: "translate(323.912 568.069)",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_770",
    "data-name": "Caminho 770",
    d: "M401.343,792.3h10.582l22.71-211.984H420.748Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_771",
    "data-name": "Caminho 771",
    d: "M310.552,792.3h10.585L344.9,580.313H331.016Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_358",
    "data-name": "Ret\\xE2ngulo 358",
    width: 114.942,
    height: 12.244,
    transform: "translate(323.911 568.069)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_359",
    "data-name": "Ret\\xE2ngulo 359",
    width: 79.369,
    height: 3.66,
    transform: "translate(491.494 564.41)",
    fill: "#3e3e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_772",
    "data-name": "Caminho 772",
    d: "M660.98,744.065l7.508,41.244-51.263,9.6c-.618-4.952,24.063-19.753,24.063-19.753l-5.9-26.228Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250",
    "data-name": "Grupo 250",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_773",
    "data-name": "Caminho 773",
    d: "M656.716,769.964a2.127,2.127,0,0,1,1.894,2.118,2.046,2.046,0,0,1-2.082,1.9,2.248,2.248,0,0,1-1.995-2.254,2.125,2.125,0,0,1,2.385-1.733",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    "data-name": "Grupo 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    "data-name": "Grupo 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_774",
    "data-name": "Caminho 774",
    d: "M668.482,785.307l-.919-4.128L618.757,791.93s-2.1,1.421-1.539,2.981Z",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_775",
    "data-name": "Caminho 775",
    d: "M640.4,775.047c.055.25,1.329.129,2.711.7,1.4.538,2.234,1.5,2.447,1.361.219-.091-.432-1.518-2.119-2.184s-3.137-.1-3.039.12",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_776",
    "data-name": "Caminho 776",
    d: "M635.441,778.283c-.013.253,1.153.476,2.2,1.375,1.074.869,1.5,1.973,1.752,1.917.241-.005.14-1.505-1.184-2.6s-2.808-.934-2.768-.694",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_777",
    "data-name": "Caminho 777",
    d: "M633.592,785.289c.237.011.352-1.3-.55-2.556s-2.173-1.576-2.24-1.348c-.1.231.8.824,1.518,1.868.748,1.02,1.016,2.064,1.27,2.04",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_778",
    "data-name": "Caminho 778",
    d: "M639.72,768.924c.147.209,1.231-.351,2.665-.52,1.429-.2,2.619.07,2.71-.17.11-.208-1.139-.934-2.823-.711s-2.71,1.227-2.551,1.4",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_779",
    "data-name": "Caminho 779",
    d: "M639.8,762.612a4.9,4.9,0,0,0,2.566-.494,11.8,11.8,0,0,0,2.528-1.329,12.4,12.4,0,0,0,1.33-1.057,3.252,3.252,0,0,0,.659-.75,1.112,1.112,0,0,0-.134-1.354,1.4,1.4,0,0,0-1.209-.367,3.49,3.49,0,0,0-.938.313,9.224,9.224,0,0,0-3.57,2.845,4.381,4.381,0,0,0-1.119,2.367c.129.061.561-.83,1.6-1.967a10.518,10.518,0,0,1,2.049-1.72,9.766,9.766,0,0,1,1.388-.731c.516-.243.978-.33,1.163-.119.067.081.081.117,0,.3a2.631,2.631,0,0,1-.487.55,13.951,13.951,0,0,1-1.209,1.03,14.521,14.521,0,0,1-2.309,1.415,18.244,18.244,0,0,0-2.316,1.07",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_780",
    "data-name": "Caminho 780",
    d: "M640.194,762.911a4.155,4.155,0,0,0,.212-2.606,8.449,8.449,0,0,0-1.822-4.177,2.158,2.158,0,0,0-1.88-.99,1.22,1.22,0,0,0-.939.918,3.572,3.572,0,0,0-.087.989,5.876,5.876,0,0,0,.322,1.73,6.012,6.012,0,0,0,1.593,2.445c1.251,1.141,2.351,1.245,2.358,1.156.059-.141-.9-.461-1.909-1.593a6.021,6.021,0,0,1-1.264-2.26,5.362,5.362,0,0,1-.231-1.493c-.021-.561.1-1.038.315-1.02.253-.052.77.276,1.055.672a8.675,8.675,0,0,1,.9,1.272,9.439,9.439,0,0,1,.978,2.47c.353,1.491.26,2.478.4,2.49",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    "data-name": "Caminho 781",
    d: "M601.219,750.709l8.054,41.14L558.145,802.13c-.683-4.947,23.8-20.072,23.8-20.072L575.7,755.911Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_345",
    "data-name": "Grupo 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M597.309,776.664a2.131,2.131,0,0,1,1.923,2.089,2.046,2.046,0,0,1-2.058,1.923,2.243,2.243,0,0,1-2.024-2.221,2.124,2.124,0,0,1,2.361-1.766",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    "data-name": "Grupo 265",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M609.278,791.852l-.974-4.117-48.662,11.4s-2.077,1.448-1.5,3Z",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    "data-name": "Caminho 784",
    d: "M581.066,781.964c.059.247,1.33.11,2.719.666,1.406.519,2.256,1.474,2.466,1.329.22-.094-.452-1.512-2.147-2.155s-3.138-.057-3.038.161",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    "data-name": "Caminho 785",
    d: "M576.143,785.265c-.009.253,1.159.461,2.219,1.344,1.084.855,1.53,1.954,1.776,1.894.242-.008.121-1.506-1.219-2.581s-2.819-.9-2.776-.659",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    "data-name": "Caminho 786",
    d: "M574.389,792.3c.237.008.33-1.31-.583-2.55s-2.193-1.546-2.255-1.318c-.1.234.8.814,1.539,1.843.759,1.01,1.043,2.049,1.3,2.024",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M580.3,775.852c.151.206,1.227-.368,2.657-.557,1.429-.219,2.62.035,2.707-.2.11-.21-1.15-.919-2.831-.674s-2.7,1.262-2.529,1.429",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M580.3,769.541a4.9,4.9,0,0,0,2.559-.528,11.775,11.775,0,0,0,2.514-1.362,12.425,12.425,0,0,0,1.314-1.076,3.189,3.189,0,0,0,.652-.757,1.112,1.112,0,0,0-.153-1.352,1.4,1.4,0,0,0-1.21-.351,3.438,3.438,0,0,0-.933.33,9.256,9.256,0,0,0-3.533,2.891,4.367,4.367,0,0,0-1.088,2.383c.131.061.55-.836,1.575-1.987a10.491,10.491,0,0,1,2.025-1.747,9.883,9.883,0,0,1,1.38-.749c.513-.251.972-.347,1.16-.135.07.082.082.117,0,.3a2.627,2.627,0,0,1-.481.55,13.372,13.372,0,0,1-1.2,1.044,14.392,14.392,0,0,1-2.285,1.447,17.9,17.9,0,0,0-2.3,1.1",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    "data-name": "Caminho 789",
    d: "M580.7,769.833a4.17,4.17,0,0,0,.177-2.61A8.427,8.427,0,0,0,579,763.066a2.157,2.157,0,0,0-1.892-.964,1.215,1.215,0,0,0-.926.929,3.494,3.494,0,0,0-.075.989,5.824,5.824,0,0,0,.345,1.726,6.026,6.026,0,0,0,1.626,2.425c1.267,1.124,2.369,1.209,2.373,1.124.058-.141-.91-.448-1.931-1.569a6.036,6.036,0,0,1-1.291-2.244,5.349,5.349,0,0,1-.25-1.49c-.03-.56.085-1.039.3-1.025.253-.055.769.267,1.064.66a8.815,8.815,0,0,1,.913,1.261,9.387,9.387,0,0,1,1.011,2.455c.371,1.486.292,2.475.439,2.486",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M631.061,758.932l-19.883-110.7a31.658,31.658,0,0,1,31.152-37.248h70.137L758.3,631.3a28.409,28.409,0,0,1-28.409,28.41q-1.113,0-2.223-.087l-74.84-5.87L663.6,754.021Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M573.048,764.794,550.355,648.23a31.659,31.659,0,0,1,31.154-37.247h70.136L697.477,631.3v30.726L592,653.747l13.816,103.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M605.816,757.331a8.179,8.179,0,0,1-.241-1.242q-.2-1.317-.549-3.576c-.452-3.179-1.091-7.663-1.875-13.174-1.521-11.191-3.606-26.543-5.91-43.5-2.134-16.287-4.073-31.09-5.508-42.055l.116.187c-5.024-3.455-8.85-6.55-11.586-8.565l-3.145-2.329a9.848,9.848,0,0,1-1.086-.83,1.134,1.134,0,0,1,.308.162l.864.54c.753.487,1.847,1.232,3.234,2.218,2.791,1.943,6.677,4.98,11.707,8.359l.1.067.016.12,5.7,42.028c2.223,16.969,4.232,32.33,5.7,43.53.688,5.526,1.246,10.018,1.649,13.206q.257,2.268.411,3.593a8.327,8.327,0,0,1,.093,1.261",
    fill: "#1f0735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M539.411,564.664l4.976-9.324a2.993,2.993,0,0,1,2.621-1.319l2.224.1,3.786-3.534h4.42l3.408-2.27,13.126,2.528,10.8,2.9-6.147,12.215-6.166-1.3-10.349-.177a11.639,11.639,0,0,1-7.983-3.363,9.829,9.829,0,0,0-6.912-2.84s-3.25,7.268-7.8,6.386",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M655.182,489.814c-6.376,4.552-3.754,16.768-3.84,23.176-.192,14.3,1.166,27.721,1.914,29.968,1.094,3.28,5.057,31.233,5.057,31.233l-6.668,36.8s8.611,21.971,45.831,21.751l18.548-4.43a19.259,19.259,0,0,0,14.717-20.372l-4.221-49.412-5.624-40.1c-1.47-21.04-14.65-32.237-31.492-31.039Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_270",
    "data-name": "Grupo 270",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_269",
    "data-name": "Grupo 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352",
    "data-name": "Grupo 352",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_268",
    "data-name": "Grupo 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_266",
    "data-name": "Grupo 266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    "data-name": "Caminho 795",
    d: "M670.458,627.939c-4.067-2.119,1.4-43.258,6.156-64.325,1.854-8.213,4.318-16.708,10.153-22.776,4.6-4.781,10.92-7.61,17.389-9.063s11.73-1.636,18.357-1.812l5.838,93.645s-40.371,13.443-57.9,4.331",
    fill: "#3e3e87"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_796",
    "data-name": "Caminho 796",
    d: "M655.182,489.814a25.241,25.241,0,0,0-18.094,13.992c-4.69,9.727-25.194,50.224-25.194,50.224l-31.348-2.089-6.265,14.3L617.3,577.776c8.86,1.7,16.6-3.71,20.97-11.7l18.014-32.958Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_797",
    "data-name": "Caminho 797",
    d: "M615.619,561.094c-.146.126-1.354-1.094-2.279-2.968s-1.174-3.57-.989-3.611c.206-.052.747,1.5,1.642,3.287s1.786,3.163,1.622,3.3",
    fill: "#3e3e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    "data-name": "Caminho 798",
    d: "M660.525,521.923c.185.084-1.892,5.056-4.635,11.11s-5.119,10.89-5.3,10.806,1.889-5.056,4.635-11.11,5.118-10.89,5.3-10.807",
    fill: "#3e3e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    "data-name": "Caminho 799",
    d: "M640.3,498.826c.18.092-5.981,12.354-13.76,27.38s-14.234,27.139-14.415,27.04,5.979-12.351,13.761-27.383,14.231-27.136,14.411-27.04",
    fill: "#089fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M652.09,507.836c0-.04.278-.079.727.11a2.487,2.487,0,0,1,1.342,1.515,2.61,2.61,0,0,1-1,2.84,2.954,2.954,0,0,1-1.791.506c-.627,0-1.227-.119-1.813-.161a3.443,3.443,0,0,0-2.858,1.048,3.306,3.306,0,0,0-.928,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.053-.58-1.252-2.348a3.709,3.709,0,0,1,.948-2.841,4.031,4.031,0,0,1,3.408-1.319c1.268.129,2.4.382,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.353-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M693.645,508.3c0-.041.279-.08.727.109a2.486,2.486,0,0,1,1.342,1.516,2.609,2.609,0,0,1-1,2.839,2.962,2.962,0,0,1-1.791.507c-.627,0-1.227-.12-1.813-.162a3.436,3.436,0,0,0-2.858,1.048,3.3,3.3,0,0,0-.929,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.054-.58-1.252-2.348a3.719,3.719,0,0,1,.948-2.841,4.026,4.026,0,0,1,3.408-1.319c1.268.13,2.4.382,3.163-.166a2.089,2.089,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.352-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M693.14,538.341c.038.014.01.291-.282.679a2.483,2.483,0,0,1-1.792.942,2.611,2.611,0,0,1-2.517-1.649,2.956,2.956,0,0,1-.062-1.861c.154-.606.41-1.162.591-1.722a3.436,3.436,0,0,0-.329-3.027,3.3,3.3,0,0,0-2.064-1.467,5.731,5.731,0,0,0-2.481.148,2.785,2.785,0,0,1,2.58-.661,3.712,3.712,0,0,1,2.528,1.6,4.03,4.03,0,0,1,.464,3.628c-.428,1.2-.945,2.239-.6,3.112a2.1,2.1,0,0,0,1.875,1.38,2.4,2.4,0,0,0,1.6-.619c.32-.285.439-.509.492-.484",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M674.925,580.965c.038.013.01.29-.282.678a2.477,2.477,0,0,1-1.792.94,2.606,2.606,0,0,1-2.517-1.648,2.956,2.956,0,0,1-.062-1.861c.154-.606.41-1.164.591-1.721a3.44,3.44,0,0,0-.329-3.029,3.3,3.3,0,0,0-2.064-1.466,5.729,5.729,0,0,0-2.481.146,2.781,2.781,0,0,1,2.58-.659,3.713,3.713,0,0,1,2.528,1.6,4.027,4.027,0,0,1,.465,3.628c-.429,1.2-.945,2.24-.6,3.112a2.1,2.1,0,0,0,1.874,1.378,2.4,2.4,0,0,0,1.6-.616c.32-.286.44-.509.492-.486",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    "data-name": "Caminho 804",
    d: "M712.264,518.621c0-.041.279-.079.727.109a2.486,2.486,0,0,1,1.342,1.516,2.611,2.611,0,0,1-1,2.84,2.967,2.967,0,0,1-1.791.506c-.627,0-1.227-.12-1.813-.162a3.443,3.443,0,0,0-2.858,1.048,3.306,3.306,0,0,0-.928,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.053-.58-1.254-2.348a3.719,3.719,0,0,1,.949-2.841,4.028,4.028,0,0,1,3.408-1.319c1.268.128,2.4.382,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.353-.243-.6-.306-.588-.363",
    fill: "#3e3e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    "data-name": "Caminho 805",
    d: "M668.868,556.374c-.036.019-.212-.2-.28-.679a2.486,2.486,0,0,1,.6-1.935,2.614,2.614,0,0,1,2.948-.617,2.971,2.971,0,0,1,1.362,1.27c.321.538.533,1.11.8,1.634a3.433,3.433,0,0,0,2.38,1.9,3.3,3.3,0,0,0,2.494-.427,5.735,5.735,0,0,0,1.653-1.856c.071-.031.049,1.2-1.356,2.289a3.714,3.714,0,0,1-2.921.66,4.032,4.032,0,0,1-2.9-2.23c-.549-1.15-.92-2.25-1.784-2.619a2.086,2.086,0,0,0-2.3.355,2.378,2.378,0,0,0-.689,1.566c-.025.428.05.672,0,.692",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    "data-name": "Caminho 806",
    d: "M670.906,528.128c0-.041.279-.08.727.109a2.486,2.486,0,0,1,1.342,1.516,2.609,2.609,0,0,1-1,2.839,2.961,2.961,0,0,1-1.791.507c-.627,0-1.227-.12-1.813-.162a3.437,3.437,0,0,0-2.858,1.048,3.3,3.3,0,0,0-.929,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.054-.58-1.252-2.348a3.715,3.715,0,0,1,.948-2.841,4.025,4.025,0,0,1,3.408-1.319c1.268.129,2.4.382,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.352-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    "data-name": "Caminho 807",
    d: "M670.061,594.971c0-.04.279-.079.727.11a2.487,2.487,0,0,1,1.342,1.515,2.61,2.61,0,0,1-1,2.84,2.961,2.961,0,0,1-1.791.507c-.627,0-1.227-.12-1.813-.162a3.443,3.443,0,0,0-2.858,1.048,3.306,3.306,0,0,0-.928,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.053-.58-1.253-2.348a3.71,3.71,0,0,1,.948-2.841,4.025,4.025,0,0,1,3.408-1.319c1.268.129,2.4.382,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.353-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    "data-name": "Caminho 808",
    d: "M630.26,559.349c0-.041.279-.079.727.109a2.486,2.486,0,0,1,1.342,1.516,2.611,2.611,0,0,1-1,2.84,2.967,2.967,0,0,1-1.791.506c-.627,0-1.227-.12-1.813-.162a3.437,3.437,0,0,0-2.858,1.048,3.3,3.3,0,0,0-.929,2.354,5.73,5.73,0,0,0,.737,2.375c-.01.079-1.054-.58-1.252-2.348a3.71,3.71,0,0,1,.948-2.841,4.025,4.025,0,0,1,3.408-1.319c1.268.129,2.4.382,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.379,2.379,0,0,0-.981-1.4c-.352-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    "data-name": "Caminho 809",
    d: "M640.881,539.882c.04.007.054.286-.177.712a2.486,2.486,0,0,1-1.63,1.2,2.615,2.615,0,0,1-2.739-1.257,2.963,2.963,0,0,1-.341-1.829c.06-.622.231-1.208.33-1.789a3.447,3.447,0,0,0-.783-2.947,3.289,3.289,0,0,0-2.261-1.136,5.714,5.714,0,0,0-2.431.518c-.077-.017.673-1,2.452-1.037a3.713,3.713,0,0,1,2.741,1.2,4.031,4.031,0,0,1,1.005,3.517c-.243,1.251-.6,2.355-.121,3.165a2.089,2.089,0,0,0,2.06,1.081,2.4,2.4,0,0,0,1.485-.85c.273-.33.357-.571.413-.55",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    "data-name": "Caminho 810",
    d: "M671.3,504.315c.04.007.054.286-.177.712a2.486,2.486,0,0,1-1.63,1.2,2.611,2.611,0,0,1-2.738-1.256,2.97,2.97,0,0,1-.341-1.829c.06-.623.231-1.21.33-1.79a3.441,3.441,0,0,0-.783-2.947,3.3,3.3,0,0,0-2.261-1.137,5.743,5.743,0,0,0-2.431.518c-.076-.019.673-1,2.452-1.036a3.709,3.709,0,0,1,2.741,1.2,4.026,4.026,0,0,1,1.005,3.516c-.243,1.253-.6,2.359-.121,3.167a2.088,2.088,0,0,0,2.06,1.081,2.383,2.383,0,0,0,1.485-.85c.273-.33.357-.569.413-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    "data-name": "Caminho 811",
    d: "M712.077,501.9c.04.006.054.286-.177.712a2.493,2.493,0,0,1-1.631,1.2,2.614,2.614,0,0,1-2.737-1.257,2.97,2.97,0,0,1-.341-1.829c.06-.623.231-1.209.33-1.79a3.439,3.439,0,0,0-.784-2.946,3.292,3.292,0,0,0-2.26-1.137,5.707,5.707,0,0,0-2.431.518c-.076-.017.673-1,2.452-1.036a3.708,3.708,0,0,1,2.741,1.2,4.031,4.031,0,0,1,1.005,3.517c-.243,1.251-.6,2.356-.121,3.165a2.09,2.09,0,0,0,2.059,1.081,2.394,2.394,0,0,0,1.486-.85c.273-.33.357-.57.413-.55",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    "data-name": "Caminho 812",
    d: "M604.783,564.427c.04.007.054.287-.177.712a2.484,2.484,0,0,1-1.63,1.2,2.61,2.61,0,0,1-2.738-1.257,2.968,2.968,0,0,1-.347-1.826c.061-.623.231-1.21.33-1.791a3.44,3.44,0,0,0-.784-2.946,3.3,3.3,0,0,0-2.26-1.137,5.751,5.751,0,0,0-2.43.518c-.077-.019.673-1,2.451-1.036a3.718,3.718,0,0,1,2.742,1.2,4.029,4.029,0,0,1,1,3.518c-.242,1.253-.6,2.358-.12,3.167a2.084,2.084,0,0,0,2.058,1.08,2.387,2.387,0,0,0,1.487-.85c.272-.329.357-.57.413-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    "data-name": "Caminho 813",
    d: "M670.143,668.527,669.032,792.3h7.049l.525-121.307s.352-5.544,4.581-5.913,67.559,2.822,67.559,2.822L767.41,792.3h8.1L757.286,667.915s-53.19-17.989-79.623-12.446c0,0-6.345-1.17-6.7,3.7s-.823,9.363-.823,9.363",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M671.381,654.224s11-85.815,14.961-100.392a26.3,26.3,0,0,1,12.2-15.584,20.694,20.694,0,0,1,11.167-2.958l58.421,1.281a8.828,8.828,0,0,1,8.521,10.223l-19.367,121.12c-21.5-.053-71.8,0-71.8,0s-68.812-7.512-79.375-7.973c-6.607-.287-7.1,2.25-7.657,5.02-6.194-5.019-2.5-15.327,5.459-14.839Z",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M776.246,542.465a2.621,2.621,0,0,1-.5.038l-1.472.036-5.662.069-20.82.116-14.375.046-8.009.018-4.189.009c-1.414.009-2.858-.026-4.267.088A15.737,15.737,0,0,0,703.7,553.354a26.307,26.307,0,0,0-.989,4.61q-.389,2.381-.784,4.8-.792,4.839-1.6,9.8c-4.377,26.453-8.338,50.394-11.212,67.775l-3.48,20.526c-.421,2.386-.752,4.257-.984,5.575-.11.6-.2,1.083-.273,1.446a.252.252,0,1,1-.074-.013c.05-.365.118-.846.2-1.458.2-1.319.483-3.2.847-5.6.77-4.9,1.883-11.913,3.25-20.563,2.821-17.389,6.705-41.346,11-67.811q.812-4.961,1.607-9.8.4-2.421.788-4.8a27.055,27.055,0,0,1,1.028-4.726,16.415,16.415,0,0,1,13.866-10.907c1.491-.11,2.917-.072,4.333-.077l4.188.009,8.009.019,14.376.045,20.819.116,5.662.069,1.472.036a2.462,2.462,0,0,1,.5.038",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M598.344,668.527,595.136,792.3h7.05l1.827-121.115s.085-7.21,5.578-6.609c4.221.462,68.169,7.9,68.169,7.9L699.29,792.3H707.4L685.486,667.915l-78.376-9.876a8.382,8.382,0,0,0-4.783.723,6.969,6.969,0,0,0-3.871,6.2c-.343,4.869-.11,3.568-.11,3.568",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M758.3,536.357s-39.462,128.3-86.918,117.867l.784-6.045s36.681,6.094,79.84-111.958Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M674.773,652.789a110.449,110.449,0,0,0,7.714,39c1.429,3.6,3.3,7.4,6.788,9.087,3.455,1.667,7.552.8,11.249-.22a171.213,171.213,0,0,0,26.831-9.876c3.172-1.479,6.5-3.245,8.123-6.346,1.938-3.7.918-8.188-.19-12.213q-5.327-19.387-11.955-38.394c-.919-2.638-5.145-12.818-5.145-12.818",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M722.934,636.2a2.6,2.6,0,0,1,.019.688c0,.45-.05,1.109-.122,1.959a41.16,41.16,0,0,1-1.345,7.106,37.127,37.127,0,0,1-4.375,9.8,31.318,31.318,0,0,1-9.221,9.354,26.614,26.614,0,0,1-12.39,4.336,24.252,24.252,0,0,1-10.614-1.575,21.263,21.263,0,0,1-6.2-3.737,14.712,14.712,0,0,1-1.4-1.391,2.466,2.466,0,0,1-.428-.537c.057-.054.686.652,2.005,1.708a22.754,22.754,0,0,0,6.2,3.47,24.366,24.366,0,0,0,10.374,1.387,26.4,26.4,0,0,0,12.045-4.278,31.338,31.338,0,0,0,9.054-9.106,38.138,38.138,0,0,0,4.445-9.584,47.749,47.749,0,0,0,1.556-6.993c.246-1.679.33-2.618.388-2.614",
    fill: "#037c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    "data-name": "Caminho 820",
    d: "M704.244,671.879c-.2-.014-.18-2.766.048-6.141s.577-6.106.78-6.092.18,2.762-.049,6.141-.578,6.105-.779,6.091",
    fill: "#037c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_821",
    "data-name": "Caminho 821",
    d: "M278.144,699.6c10.249,3.579,23.619.381,32.388-6.023S325.608,678,331.2,668.7c2.387-3.971,4.716-8.112,5.471-12.681s-.356-9.713-3.9-12.7c-5.509-4.635-13.951-2.284-20.207,1.28a69.682,69.682,0,0,0-34.418,55",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_822",
    "data-name": "Caminho 822",
    d: "M289.148,724.133c6.156,8.12,16.73,11.737,26.91,12.207s20.237-2.344,29.75-5.994c3.453-1.319,7.228-3.14,8.411-6.642a8.447,8.447,0,0,0-1.8-7.835,17.568,17.568,0,0,0-6.87-4.683c-9.365-3.99-20.092-4.177-29.945-1.621s-18.46,8.267-26.455,14.566",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_823",
    "data-name": "Caminho 823",
    d: "M277.995,655.694c8.484.169,14.906-7.264,18.746-14.83a54.967,54.967,0,0,0,5.058-34.273c-.775-4.336-2.419-9.013-6.3-11.1-3.943-2.12-9.073-.724-12.38,2.294s-5.124,7.325-6.443,11.6c-4.554,14.736-3.573,31.671,1.311,46.3",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_824",
    "data-name": "Caminho 824",
    d: "M250.125,702.622C264.591,678,267,647.88,258.458,620.632c-1.386-4.42-4-9.477-8.624-9.77-5.121-.329-8.329,5.387-9.744,10.315-4.96,17.3-3.9,35.678-2.808,53.642.677,11.066,4.477,20.527,12.843,27.8",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_825",
    "data-name": "Caminho 825",
    d: "M235.083,712.747a59.165,59.165,0,0,0-35.1-37.224c-3.847-1.446-8.725-2.27-11.591.668-2.811,2.883-1.945,7.7-.142,11.3,2.913,5.815,7.642,10.487,12.352,14.971,4.287,4.077,8.737,8.17,14.157,10.54s15.371,2.974,20.326-.257",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_826",
    "data-name": "Caminho 826",
    d: "M324.768,649.493c.007.011-.079.086-.252.221l-.779.6-3.032,2.268-2.2,1.624c-.789.61-1.616,1.319-2.522,2.053-1.791,1.5-3.907,3.106-6.036,5.132l-3.407,3.1c-1.18,1.084-2.315,2.308-3.544,3.518-2.49,2.394-4.9,5.187-7.5,8.073a159.38,159.38,0,0,0-26.441,42.776c-1.421,3.611-2.841,7.017-3.87,10.314-.537,1.641-1.124,3.2-1.563,4.744s-.85,3.022-1.249,4.437c-.86,2.811-1.354,5.423-1.892,7.694-.252,1.139-.516,2.193-.709,3.174q-.255,1.47-.468,2.694l-.673,3.725c-.077.392-.14.709-.191.968a1.4,1.4,0,0,1-.089.33,1.152,1.152,0,0,1,.02-.337c.032-.26.073-.581.124-.977q.2-1.368.55-3.751c.124-.818.261-1.723.411-2.709.174-.989.421-2.047.659-3.188.5-2.284.965-4.914,1.8-7.741q.577-2.136,1.209-4.463c.431-1.55,1.005-3.121,1.532-4.77,1.009-3.319,2.418-6.746,3.826-10.377a155.919,155.919,0,0,1,26.546-42.947c2.617-2.886,5.056-5.674,7.57-8.062,1.24-1.209,2.39-2.426,3.584-3.5l3.45-3.078c2.158-2.008,4.3-3.6,6.12-5.07.919-.722,1.758-1.415,2.562-2.013l2.239-1.58,3.11-2.165.819-.55a1.222,1.222,0,0,1,.291-.167",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_827",
    "data-name": "Caminho 827",
    d: "M343.925,717.745a5.613,5.613,0,0,1-.989-.167c-.649-.109-1.586-.366-2.818-.57a79.13,79.13,0,0,0-10.473-1.281,76.424,76.424,0,0,0-62.052,25.82,79.415,79.415,0,0,0-6.472,8.331c-.723,1.019-1.209,1.859-1.581,2.4a5.463,5.463,0,0,1-.582.82,5.585,5.585,0,0,1,.465-.891c.336-.566.785-1.429,1.476-2.475a70.729,70.729,0,0,1,6.326-8.5,75.189,75.189,0,0,1,62.445-25.983,70.277,70.277,0,0,1,10.5,1.5c1.227.245,2.158.538,2.8.7a5.471,5.471,0,0,1,.959.3",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_828",
    "data-name": "Caminho 828",
    d: "M290.5,605.324a1.7,1.7,0,0,1-.056.383c-.059.285-.135.649-.231,1.106l-.95,4.238c-.833,3.678-2.1,8.987-3.7,15.539-3.188,13.1-7.819,31.152-12.641,51.151-2.4,10-4.567,19.566-6.438,28.279-1.834,8.72-3.4,16.6-4.564,23.235-.625,3.313-1.1,6.325-1.539,8.966s-.805,4.917-1.078,6.783c-.283,1.826-.507,3.261-.668,4.287-.079.459-.14.825-.19,1.114a1.7,1.7,0,0,1-.089.377,1.719,1.719,0,0,1,.019-.386c.032-.291.073-.659.124-1.123.13-1.034.311-2.476.542-4.309.231-1.869.543-4.159.963-6.807s.847-5.667,1.441-8.988c1.1-6.656,2.623-14.545,4.427-23.281,1.838-8.728,3.991-18.3,6.389-28.308,4.827-20.006,9.533-38.034,12.838-51.115,1.643-6.5,2.976-11.779,3.911-15.483.458-1.791.818-3.2,1.075-4.208l.3-1.091a1.661,1.661,0,0,1,.124-.366",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_829",
    "data-name": "Caminho 829",
    d: "M257.283,748.8a1.063,1.063,0,0,1-.091-.3c-.055-.24-.121-.531-.2-.888q-.263-1.259-.713-3.428c-.612-2.977-1.429-7.3-2.351-12.658-1.854-10.71-4.055-25.587-5.407-42.131-.66-8.275-1.02-16.176-1.18-23.366-.119-7.19-.057-13.67.167-19.1.066-2.72.246-5.173.365-7.33s.262-4.011.4-5.525l.321-3.485c.04-.363.073-.66.1-.9a1.022,1.022,0,0,1,.056-.306,1.059,1.059,0,0,1,.013.313c-.009.245-.02.549-.034.909-.046.855-.11,2.022-.192,3.493-.1,1.516-.213,3.37-.287,5.528s-.227,4.608-.263,7.324c-.162,5.427-.175,11.9-.021,19.073.2,7.178.577,15.059,1.231,23.326,1.35,16.518,3.473,31.384,5.2,42.106.865,5.363,1.6,9.7,2.138,12.688q.369,2.181.586,3.451c.055.361.1.659.136.9a1.046,1.046,0,0,1,.022.311",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_830",
    "data-name": "Caminho 830",
    d: "M258.353,751.93a4.7,4.7,0,0,1-.377-.849c-.242-.631-.558-1.453-.953-2.477q-.308-.816-.678-1.791-.434-.966-.929-2.08t-1.061-2.393c-.375-.847-.86-1.7-1.319-2.621l-1.476-2.87q-.849-1.457-1.759-3.023c-1.163-2.125-2.665-4.235-4.113-6.532a154.684,154.684,0,0,0-10.9-13.924,171.293,171.293,0,0,0-12.5-12.516c-2.078-1.759-3.982-3.508-5.906-4.977L213.64,693.7l-2.6-1.917c-1.641-1.246-3.188-2.288-4.543-3.2-1.345-.932-2.52-1.708-3.509-2.3l-2.238-1.414a4.956,4.956,0,0,1-.759-.537,4.654,4.654,0,0,1,.828.417l2.306,1.31c1.012.558,2.21,1.3,3.58,2.209,1.382.879,2.951,1.9,4.617,3.124l2.638,1.888,2.773,2.159c1.947,1.456,3.872,3.2,5.971,4.946a161.758,161.758,0,0,1,12.6,12.532,146.9,146.9,0,0,1,10.906,14.026c1.445,2.32,2.936,4.452,4.082,6.6q.9,1.582,1.734,3.059.751,1.515,1.444,2.906c.447.932.919,1.8,1.28,2.655s.7,1.664,1.019,2.419.607,1.457.879,2.11l.624,1.818c.347,1.045.623,1.883.835,2.529a4.766,4.766,0,0,1,.246.893",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_831",
    "data-name": "Caminho 831",
    d: "M319.4,678.052c0,.11-1.759.11-4.57.266a81.7,81.7,0,0,0-21.564,4.1c-2.678.885-4.307,1.527-4.349,1.428a4.326,4.326,0,0,1,1.086-.588c.715-.347,1.774-.791,3.1-1.294a65,65,0,0,1,21.709-4.123c1.419-.017,2.567.008,3.359.065a4.24,4.24,0,0,1,1.227.151",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_832",
    "data-name": "Caminho 832",
    d: "M330.318,731.352c-.206.11-1.842-4.609-5.955-8.982-4.058-4.424-8.639-6.4-8.516-6.6a10.092,10.092,0,0,1,2.94,1.3,25.982,25.982,0,0,1,10.453,11.256,10.193,10.193,0,0,1,1.079,3.028",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_833",
    "data-name": "Caminho 833",
    d: "M293.1,625.313c.137.145-2.528,2.786-5.432,6.364s-4.972,6.705-5.145,6.6c-.152-.086,1.659-3.42,4.617-7.036s5.848-6.065,5.961-5.935",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_834",
    "data-name": "Caminho 834",
    d: "M284.362,610.217c.186-.031.775,2.529,1.319,5.71s.832,5.793.646,5.826-.775-2.529-1.319-5.71-.832-5.793-.646-5.826",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_835",
    "data-name": "Caminho 835",
    d: "M257.3,657.582c.167.087-1.73,4.077-4.234,8.91s-4.674,8.684-4.837,8.6,1.728-4.075,4.234-8.911,4.673-8.684,4.837-8.6",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_836",
    "data-name": "Caminho 836",
    d: "M241.19,641.5c.169-.084,1.776,2.8,3.589,6.447s3.148,6.667,2.979,6.749-1.776-2.8-3.59-6.447-3.147-6.665-2.978-6.749",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    "data-name": "Caminho 837",
    d: "M217.525,696.5c-.045.2-2.917-.363-6.5-.608-3.58-.263-6.5-.109-6.518-.315-.022-.175,2.921-.632,6.567-.366s6.5,1.12,6.45,1.289",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    "data-name": "Caminho 838",
    d: "M233.689,745.117l8.053,42.347a5.936,5.936,0,0,0,5.826,4.828h23.8a5.937,5.937,0,0,0,5.857-4.961l7-42.211Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M236.3,758.88h45.5l2.42-13.765H233.689Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    "data-name": "Caminho 840",
    d: "M236.3,758.88l.954,5.019h43.847l.7-5.019Z",
    fill: "#fafafa"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenImageAcium);
export default __webpack_public_path__ + "static/media/tokenImageAcium.c90920b225dfae9b5fb480c5f46a385c.svg";
export { ForwardRef as ReactComponent };